// import axios from "axios";
// import { useEffect, useState } from "react";
// import Foot from "../../components/Footer/Foot";
import Hero from "../../components/Hero/Hero";
// import Nav from "../../components/Navbar/Nav";
import Sum from "../../components/Summary/Sum";
import Two from "../../components/Two/Two";
// import data from "../../utils/constants/provinces";


function Global(){


// const [covids, setCovid] =  useState("");

// const fetch = useEffect(async() => {
//       //fetch data dari axios
//       const { data : {confirmed, recovered, deaths, lastUpdate}} = await axios(URL);
//     //   console.log(response.data);


//       const exportData = {
//         confirmed: confirmed,
//         recovered: recovered,
//         deaths: deaths,
//         lastUpdate: lastUpdate,

//       }
     
//       return exportData;
// } , []);

// console.log(covids);

// const URL = "https://covid19.mathdro.id/api/";

// const fetchData = async() => {
//     try {
//         const response = await axios.get(URL);
//         // return response;
//         console.log(fetchData);

//     } catch (error) {
        
//     }
// }



// const [sum, setSum] = useState('');

// useEffect(async() => {
     
//     // const response = await fetch( 
//     //     "https://covid19.mathdro.id/api/"

//     // );

//     // const data = await response.json();
//     // console.log(data);

//     // setSum(data);
    
// }, []);

// console.log(sum);



// async function fetchData(){
//     const response = await fetch( 
//         "https://covid19.mathdro.id/api/"

//     );

//     const data = await response.json();
//     // console.log(data);

//     setSum(data);

// }

// console.log(sum);

// useEffect(fetchData, []);

    return(
 
        //merender dari react-router
        <div>
            <Hero />
            <Two />
            {/* <Nav /> */}
            {/* <h2>Hai</h2> */}
            {/* <Foot /> */}
            <Sum />
            
        </div>
    )
}

export default Global;